// @flow
import EmptyOrder from './EmptyOrder';

export default EmptyOrder;
